/* eslint-disable import/prefer-default-export, no-param-reassign */
import EventClass from "common/utils/ui/event-class";

export class SignInModalToggleClass extends EventClass {
  #modalSelector = ".js-sign-in-modal";

  #state = "sign-in";

  get #$modal() {
    return document.querySelector(this.#modalSelector);
  }

  get #dataTextState() {
    return `data-${this.#state}-text`;
  }

  get #dataVisibilityState() {
    return `data-${this.#state}-container`;
  }

  #hideAllContainers() {
    this.#$modal.querySelectorAll(`[${this.#dataVisibilityState}]`).forEach($item => {
      $item.classList.add("hidden");
    });
  }

  #showAllContainers() {
    this.#$modal.querySelectorAll(`[${this.#dataVisibilityState}]`).forEach($item => {
      $item.classList.remove("hidden");
    });
  }

  event(event, $target) {
    super.event(event, $target);

    this.#hideAllContainers();

    this.#state = this.#state === "sign-in" ? "sign-up" : "sign-in";

    this.#$modal.querySelectorAll(`[${this.#dataTextState}]`).forEach($item => {
      $item.textContent = $item.getAttribute(this.#dataTextState);
    });

    this.#showAllContainers();
  }
}
